var exports = {
  "kL": "MessageListPage.module__container___UFR1cT",
  "Qs": "MessageListPage.module__content___UFR1cT",
  "XG": "MessageListPage.module__scroller___UFR1cT",
  "D": "MessageListPage.module__endState___UFR1cT",
  "Gm": "MessageListPage.module__endStateContent___UFR1cT",
  "KH": "MessageListPage.module__endStateIcon___UFR1cT",
  "Ep": "MessageListPage.module__endStateText___UFR1cT",
  "VH": "MessageListPage.module__endStateTitle___UFR1cT",
  "fE": "MessageListPage.module__endStateDescription___UFR1cT",
  "p$": "MessageListPage.module__emptyState___UFR1cT",
  "ig": "MessageListPage.module__emptyStateContent___UFR1cT",
  "AI": "MessageListPage.module__emptyStateIcon___UFR1cT",
  "q6": "MessageListPage.module__emptyStateText___UFR1cT",
  "vo": "MessageListPage.module__emptyStateTitle___UFR1cT",
  "Li": "MessageListPage.module__emptyStateDescription___UFR1cT",
  "wx": "MessageListPage.module__header___UFR1cT",
  "DD": "MessageListPage.module__title___UFR1cT",
};

module.exports = exports;
